export default __webpack_public_path__ + "static/media/webimg6.ade3212c.jpg";